import React from "react";
import { Pill } from "./common";
import { sig } from "../lib/format";

/**
 * Substanzen row -> Nr.x -> compound.
 *
 * This is the table a scientist checks before trusting anything downstream: the
 * instrument files carry only anonymous series labels, and everything else in
 * the analysis depends on this reconstruction being right.
 */
export function AssignmentTable({ mapping }) {
  return (
    <div className="table-scroll">
      <table>
        <thead>
          <tr>
            <th>Series</th>
            <th className="num">Substanzen row</th>
            <th>Compound</th>
            <th className="num unit">Assay conc. [µM]</th>
            <th>Project</th>
            <th>Batch</th>
            <th>Applies to</th>
          </tr>
        </thead>
        <tbody>
          {mapping.assignments.map((a) => (
            <tr key={`${a.series}-${a.substanzen_row}-${a.condition || "all"}`}>
              <td className="mono">{a.series}</td>
              <td className="num">{a.substanzen_row}</td>
              <td>
                {a.compound}{" "}
                {a.is_positive_control && <Pill kind="info">control</Pill>}
              </td>
              <td className="num">{sig(a.concentration_in_assay)}</td>
              <td>{a.project || "—"}</td>
              <td>{a.batch || "—"}</td>
              <td className="muted">{a.condition || "all conditions"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/** The compounds as they will be fitted, after replicate and block pooling. */
export function CompoundTable({ mapping }) {
  return (
    <div className="table-scroll">
      <table>
        <thead>
          <tr>
            <th>Compound</th>
            <th>Role</th>
            <th className="num unit">Starting conc. [µM]</th>
            <th className="num">Replicates</th>
            <th>Series</th>
          </tr>
        </thead>
        <tbody>
          {mapping.compounds.map((c) => (
            <tr key={c.compound}>
              <td>{c.compound}</td>
              <td>
                {c.is_positive_control && <Pill kind="info">positive control</Pill>}
                {c.is_vehicle && <Pill kind="neutral">vehicle</Pill>}
                {!c.is_positive_control && !c.is_vehicle && (
                  <span className="muted">test compound</span>
                )}
              </td>
              <td className="num">{c.starting_concentrations.map((v) => sig(v)).join(", ")}</td>
              <td className="num">{c.series.length}</td>
              <td className="mono muted">{c.series.join(", ")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
